import { QueryClient, useQuery } from "react-query";
import { getAssetShortName } from "@syla/shared/helpers/assets/getAssetShortName";
import { getAssets } from "../api/asset/getAssets";
import { Asset } from "../types/asset/asset";
import {
  useTransactionsStore,
  TRANSACTIONS_CACHE_KEY,
} from "./transactionsStore";

export function useQueryAssets(): Asset[] | undefined {
  const { data: assets } = useQuery(
    [TRANSACTIONS_CACHE_KEY, "assets"],
    () => getAssets(),
    {
      staleTime: 60 * 60 * 1000, // time before data may be refetched
    }
  );
  if (assets)
    useTransactionsStore.setState({
      assets: Object.fromEntries(assets.map((asset) => [asset._id, asset])),
    });
  return assets;
}

export const useQueryAssetOptions: () => SelectOptionType[] = () =>
  useQueryAssets()?.map((asset) => ({
    value: asset._id,
    label: getAssetShortName(asset),
    icon: asset.image,
  })) ?? [];

export const invalidateAssetsQuery: (
  client: QueryClient
) => Promise<void> = async (client: QueryClient) => {
  return client.invalidateQueries([TRANSACTIONS_CACHE_KEY, "assets"]);
};
